import firebase from 'firebase/app'
import "@firebase/firestore";
import "firebase/database";
import "firebase/auth";
import "firebase/storage";
import "firebase/messaging";

export const config = {
    apiKey: process.env.REACT_APP_FIREBASE_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
    projectId: process.env.REACT_APP_FIREBASE_PROJEECT,
    storageBucket: process.env.REACT_APP_FIREBASE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING
};
const fire = firebase.initializeApp(config);

export const database = fire.database();
export const auth = fire.auth();
export const storage = fire.storage();
export const firestore = firebase.firestore();
firestore.settings({timestampsInSnapshots: true});


export const messaging = () => {
    try {
        const mes = fire.messaging();
        mes.usePublicVapidKey(process.env.REACT_APP_FIREBASE_MESSAGING_KEY);
        return mes;
    } catch(e) {
        return null;
    }
};

export default fire;


// WEBPACK FOOTER //
// ./src/firebase/index.js